export const GET_SITE_SETTINGS_DATA = "GET_SITE_SETTINGS_DATA";
